<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <div v-on="on" style="display: inline;">
        <Prompt
          activatorSize="small"
          activatorIconSize="small"
          activatorIcon="fa-key"
          inputText="Clé d'intégration"
          @submit="v => $emit('input', v)"
        ></Prompt>
      </div>
    </template>
    <v-row dense no-gutters>Configurer la clé d'intégration</v-row>
    <v-row dense no-gutters v-show="value !== null"
      >Actuelle: {{ value }}</v-row
    >
  </v-tooltip>
</template>

<script>
export default {
  name: "RecipeKeyInput",
  props: {
    value: {
      required: true
    }
  }
};
</script>

<style></style>
